<template>
	<div class="w-100 h-100 pageBg"></div>
</template>

<script>
export default {
  name: "page",
  data() {
    return {
      
    };
  },
  created() {},
  mounted() {},
  methods: {}
};
</script>
<style scoped>
	.pageBg{background: url(../../../static/img/homeBg.png) center no-repeat; background-size:70%;}
</style>



// WEBPACK FOOTER //
// src/page/home/page.vue